<script>
/**
 * ****************************************************************************
 * @description     :   Footer
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
/**
 * Import libraries
 */
import { mapState } from 'vuex';

/**
 * import template
 */
import template from './template.html';

/**
 * Define main layout
 */
const Footer = {
    name: 'Menu',
    template: template,
    components: {},
    computed: {
        ...mapState('app', ['isMobile'])
    },
    mounted() {},
    methods: {}
};
export default Footer;
</script>
